import { render, staticRenderFns } from "./spinner-loader.vue?vue&type=template&id=983bb6d2&"
import script from "./spinner-loader.vue?vue&type=script&lang=js&"
export * from "./spinner-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports